<template lang="pug">
  .west
    h2 East Yearbook
    .grid
      .item(v-for="image, index in yearbookImages")
        .yearbook-page
          img(:src="image", @click="select(index)")

    light-box(:selected="selected", :images="yearbookImages", @close="close")
</template>

<script>

import LightBox from '@/components/LightBox'

export default {
  name: 'West',
  components: {
    LightBox
  },
  data () {
    return {
      selected: null
    }
  },
  computed: {
    yearbookImages () {
      let images = []
      for (var i = 1; i <= 78; i++) {
        images.push(require(`../assets/yearbook/EAST_YEARBOOK-${i}-min.jpg`))
      }
      return images
    }
  },
  methods: {
    select (index) {
      this.selected = index
    },
    close (e) {
      this.selected = -1
    }
  }
}
</script>


<style lang="stylus">
.yearbook-page
  cursor pointer
  &:hover
    outline 3px solid #4287f5
</style>